import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import cronstrue from 'cronstrue';
import { BlueprintSummaryComponent } from 'src/app/main/blueprint-summary/blueprint-summary.component';
import { Capability, CapabilityType } from 'src/app/models/service/capability';
import { DynamicFormModel } from 'src/app/models/service/dynamic-form-model';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';

@Component({
    selector: 'app-cob-details',
    templateUrl: './cob-details.component.html',
    styleUrls: ['./cob-details.component.scss'],
    standalone: false
})
export class CobDetailsComponent implements OnInit {
  dynamicFormModels: DynamicFormModel;
  InstallationSchemaPropertyType = InstallationSchemaPropertyType;
  instance: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private matDialogRef: MatDialogRef<BlueprintSummaryComponent>) { }
  ngOnInit(): void {
    this.dynamicFormModels = this.data.dynamicForm;
    this.instance = this.data.instance;
    if (this.instance?.cob && this.instance?.cob?.inputs) {
      const propertyKey = Object.keys(this.instance?.cob?.inputs);
      const title = propertyKey[0];
      if (this.instance?.cob?.inputs[title]) {
        if (this.instance?.cob?.inputs[title]?.Schedule1) {
          const sch1 = cronstrue.toString(this.instance?.cob?.inputs[title]?.Schedule1);
          this.dynamicFormModels[0].property.properties.find(item => item.name === 'Schedule1').value = sch1;
          this.dynamicFormModels[0].property.properties.find(item => item.name === 'Schedule1').type = InstallationSchemaPropertyType.STRING;
        } 
        if (this.instance?.cob?.inputs[title]?.Schedule2) {
          const sch1 = cronstrue.toString(this.instance?.cob?.inputs[title]?.Schedule2);
          this.dynamicFormModels[0].property.properties.find(item => item.name === 'Schedule2').value = sch1;
          this.dynamicFormModels[0].property.properties.find(item => item.name === 'Schedule2').type = InstallationSchemaPropertyType.STRING;
        }
      }
    }
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }

  typeOfPropertyValue(value): boolean {
    return typeof value == 'object' || value === '' || value === null || value === undefined;
  }
}
